import React from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import StickyHeader from './StickyHeader';
import ProductListItem from './ProductListItem';
import { StyleBean } from '../../models/Beans';
import ClipLoader from 'react-spinners/ClipLoader';
import InfiniteScroll from 'react-infinite-scroller';
import { wishlistItemKey } from '../../store/wishlist/wishlistKey';
import {
    ProductGridViewMode,
    plClassName,
    wrapperClassName,
    isEditorialHalfItem,
} from '../../utils/productGridView';

const InfinityList = (props: any) => {
    const {
        elements,
        onSticky,
        onUnSticky,
        handleOnProductClick,
        lineDiscount,
        isInBasket,
        lazyLoadMoloMaster,
        loadItems,
        hasMore,
        scrollPosition,
        isOnWishlist,
        wishlistFetching,
        wishlistMutatingKey,
        onWishlistToggle,
        gridViewMode = 'grid6' as ProductGridViewMode,
    } = props;

    const loader = <div style={{display: 'flex',justifyContent: 'center'}} key={0}><ClipLoader size={30} /></div>

    let items: any = [];
    let productIndexInCategory = 0;

    elements.map((element: any, i: number) => {
        let rendered = <div></div>

        if (element.type === 'iheader' && element.header) {
            productIndexInCategory = 0;
            rendered = <StickyHeader
                key={ element.header.description }
                title={ element.header.description }
                onSticky={onSticky}
                onUnSticky={onUnSticky}
            />              
        }

        if (element.type === 'style' && element.style) {
            const style = element.style;
            const itemIndex = productIndexInCategory;
            productIndexInCategory += 1;

            if (style) {
                const rowKey = wishlistItemKey(style.masterId, style.colorCode);
                const wishlistLoading =
                    !!wishlistFetching ||
                    (!!wishlistMutatingKey && wishlistMutatingKey === rowKey);
                rendered = <div
                    className={wrapperClassName(gridViewMode, itemIndex)}
                    onClick={ () => handleOnProductClick(style) }
                    key={style.masterColor + style.colorCode + style.description}>
                    <ProductListItem
                        product={StyleBean.build(style, 'style')}
                        discount={lineDiscount}
                        inBasket={isInBasket(style)}
                        lazyLoadMoloMaster={lazyLoadMoloMaster}
                        quantityLabel={'Available'}
                        scrollPosition={scrollPosition}
                        wishlistOn={isOnWishlist ? isOnWishlist(style) : false}
                        wishlistLoading={wishlistLoading}
                        onWishlistClick={onWishlistToggle ? (e) => onWishlistToggle(e, style) : undefined}
                        imageProfile={
                            isEditorialHalfItem(gridViewMode, itemIndex) ? 'large' : 'thumb'
                        }
                    />
                </div>
            }
        }

        return items.push(
            rendered
        );
    });
    
    return (
        <div className="product-list__list" id="sticky-container">
            <InfiniteScroll
                pageStart={0}
                threshold={800}
                loadMore={loadItems}
                hasMore={hasMore}
                loader={loader}
                useWindow={false}
            >
                <div className={plClassName(gridViewMode)}>
                    { items }
                </div>
            </InfiniteScroll>
        </div>
      );
}
 
export default trackWindowScroll(InfinityList);